export default __webpack_public_path__ + "642ece33c9f370c33c1682f4edb5eed4.png";